import { IMAGES_BASE_URL } from "./constants/baseURL";

const buildImageURI = (path) => `${IMAGES_BASE_URL}/${path}`;

export default buildImageURI;
